// Square multi-select checkbox shown on answerer rows (a number
// can have many answerers, so selection is multi not single).
// Filled charcoal with a check when selected, empty ring
// otherwise.
export function CheckBox({ selected }: { selected: boolean }) {
  if (selected) {
    return (
      <span
        className="flex items-center justify-center size-[18px] shrink-0 rounded-[5px] bg-[#1E1B17]"
        data-testid="check-box-selected"
        aria-hidden="true"
      >
        <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
          <path
            d="M2.5 6L5 8.5L9.5 3.5"
            stroke="#FFFFFF"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    )
  }
  return (
    <span
      className="size-[18px] shrink-0 rounded-[5px] border border-[#C9C2B6]"
      aria-hidden="true"
    />
  )
}
